export default function prepareDateString(dateString) {
  return dateString.split('/').reverse().join('-')
}
